import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'react';
import styled from 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../Box/Box.es.js';

const StyledHidden = styled(Box).attrs(({ isVisible }) => ({
  hidden: !isVisible
}))``;
const Hidden = maestroComponent("Hidden", StyledHidden);
Hidden.defaultProps = {
  isVisible: false
};

export { Hidden };
//# sourceMappingURL=Hidden.es.js.map
